//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";

let mappings = [];

export default {
    name: "QfPInputs",
    props: ["value"],
    data() {
        return {
            hashMapping: "",
            requiredHash: false,
            mappingList: []
        };
    },
    watch: {
        value: {
            handler(val) {
                this.hashMapping = val;
            },
            immediate: true
        }
    },
    computed: {
        ...mapState("components", ["properties", "components"])
    },
    beforeMount() {
        mappings = [...this.getMappingList()];
        this.mappingList = mappings;
    },
    methods: {
        doFilter(value, done) {
            if (value === "") {
                done(() => {
                    this.mappingList = mappings;
                });
            } else {
                const needle = value.toLowerCase();
                done(() => {
                    this.mappingList = mappings.filter(entry => entry.label.toLowerCase().includes(needle));
                });
            }
        },
        getMappingList() {
            const mappingList = [];
            Object.entries(this.properties).forEach(([key, data]) => {
                const props = data; let
                    configProps = {};
                if (this.components[props.__component].componentName === "ctrl-textbox") {
                    configProps = this.components[props.__component];
                }
                const isInNamespace = guid => {
                    let done = false; let { parent } = this.properties[guid]; let
                        currentProps;
                    while (parent && !done) {
                        currentProps = this.properties[parent];
                        if (this.components[currentProps.__component].namespace) {
                            done = true;
                        } else {
                            parent = currentProps.parent;
                        }
                    }
                    return done;
                };
                if (configProps && (configProps.get || configProps.set)) {
                    const labelValue = data.label || data.checkLabel || data.toggleLabel || data.code || key;
                    if (isInNamespace((key))) {
                        mappingList.push({
                            label: `[ ].${labelValue}`,
                            value: key,
                            icon: configProps.icon
                        });
                    } else {
                        mappingList.push({
                            label: labelValue,
                            value: key,
                            icon: configProps.icon
                        });
                    }
                }
            });
            return mappingList;
        },
        onUpdate(val) {
            this.$emit("input", val);
            this.requiredHash = false;
        }
    }
};
